import { render, staticRenderFns } from "./planPage.vue?vue&type=template&id=72c6d2a2&scoped=true"
import script from "./planPage.vue?vue&type=script&lang=js"
export * from "./planPage.vue?vue&type=script&lang=js"
import style0 from "./planPage.vue?vue&type=style&index=0&id=72c6d2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6d2a2",
  null
  
)

export default component.exports